import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {Link} from 'react-router-dom';
import {getPersianOrdinal} from '../../../utilities/helper/unitConvertor/getPersianOrdinal';
import convertNumberToPersianUnits from '../../../utilities/helper/unitConvertor/convertNumberToPersianUnit';
import ConvertNotifTypeToPersian from '../utils/convertNotifTypeToPersian';

const ActivePlanCard = (props: sponserItem) => {
  const {
    guid,
    link,
    notification_type,
    number_messages,
    position_release_queue,
    sponsoring_message_unit,
    text,
  } = props;
  
  return (
    <div className="flex flex-col border-2 border-gray-100 rounded relative px-4 pb-4 pt-8">
      <span className=" bg-white p-1 absolute right-4 -top-[13px]">
        طرح فعال
      </span>
      {/* start progressbar */}
      <div className="flex flex-col items-start gap-2">
        <div className="w-full h-[7px] rounded-lg bg-gray-50 relative">
          <span
            className="absolute top-0 left-0 h-full bg-farm-shop-500 rounded-lg"
            style={{
              width: `${
                (number_messages.number_messages_sent /
                  sponsoring_message_unit.notification_count) *
                100
              }%`,
            }}
          ></span>
          <span
            className={`text-xs text-farm-shop-500 absolute top-[15px] ${
              number_messages.number_messages_sent === 0
                ? 'hidden'
                : 'inline-block'
            }`}
            style={{
              left: `calc(${
                (number_messages.number_messages_sent /
                  sponsoring_message_unit.notification_count) *
                100
              }% - 22px)`,
            }}
          >
            {number_messages.number_messages_sent}
          </span>
        </div>
        <span className="text-gray-600 text-xs">
          {convertNumberToPersianUnits(
            sponsoring_message_unit.notification_count,
          )}
        </span>
      </div>
      {/* end progressbar */}
      <ul className="mb-0 pl-0 space-y-2 mt-4">
        <li>
          <span className="text-gray-700 inline-block ml-1">کل پیام‌ها</span>
          <span>{sponsoring_message_unit.notification_count}</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">
            پیام‌های باقی‌مانده
          </span>
          <span>{number_messages.number_messages_be_sent}</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">
            پیام‌های ارسال شده
          </span>
          <span>{number_messages.number_messages_sent}</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">دسته‌آگهی</span>
          <span>{ConvertNotifTypeToPersian(notification_type)}</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">
            جایگاه در صف انتشار
          </span>
          <span>پیام {getPersianOrdinal(position_release_queue)}</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">
            مشاهده کنندگان پیام
          </span>
          <span>{number_messages.message_viewer} نفر</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">
            ورود به صفحه تبلیغی
          </span>
          <span>{number_messages.login_advertising_page} نفر</span>
        </li>
        <li>
          <span className="text-gray-700 inline-block ml-1">متن تبلیغی</span>
          <span>{text}</span>
        </li>
        <li className="flex items-center justify-between gap-2 w-full ">
          <p className="mb-0 flex w-fit gap-1 text-gray-700 flex-1 overflow-hidden">
            <span className="shrink-0">لینک تبلیغی</span>
            <span className="line-clamp-1 overflow-ellipsis" dir="ltr">
              {link}
            </span>
          </p>
          <Link
            className="no-underline shrink-0"
            to={`/sponsor/edit-plan/${guid}`}
          >
            <SpanIcon className="icon-nameEdit text-farm-shop-500 text-base" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ActivePlanCard;
